export class MessageFormData {
    public readonly closeForm: (() => void);
    public message?: string;

    constructor(
        closeForm: (() => void)
    ) {
        this.closeForm = closeForm;
    }
}
